import Model, { belongsTo, hasMany } from '@ember-data/model';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export default class AirbnbQualityDashboardModel extends Model {
  @hasMany('airbnb-official-review', { async: false, inverse: null })
  reviews!: ModelRegistry['airbnb-official-review'][];

  @belongsTo('airbnb-quality-review-average', { async: false, inverse: null })
  reviewAverage!: ModelRegistry['airbnb-quality-review-average'];

  @hasMany('airbnb-quality-review-trend', { async: false, inverse: null })
  reviewTrends!: ModelRegistry['airbnb-quality-review-trend'][];

  @hasMany('airbnb-quality-listing', { async: false, inverse: null })
  listings!: ModelRegistry['airbnb-quality-listing'][];

  @hasMany('airbnb-quality-stat-month', { async: false, inverse: null })
  qualityStatMonths!: ModelRegistry['airbnb-quality-stat-month'][];

  @hasMany('airbnb-quality-stat-listing', { async: false, inverse: null })
  qualityStatListings!: ModelRegistry['airbnb-quality-stat-listing'][];
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'airbnb-quality-dashboard': AirbnbQualityDashboardModel;
  }
}
